import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { Image } from '../../common/image'
import { COMPONENTS } from '../../routers/constants'
import CartIllustartion from '..//Cart_Illustartion.svg'
import classes from '../index.module.scss'

export const NoCart = () => {
  return (
    <div
      className={`${classes.cartContainer} flexColumn gap5 justifyContentCenter alignItemsCenter`}
    >
      <Image
        src={CartIllustartion}
        alt="changeCurrency"
        className={classes.imgCart}
        style={{
          width: 300,
          height: '100%',
        }}
      />
      <div>
        <Element style={{ color: '#0553A5', fontSize: 48 }}>
          <Translate value="cartAndOrders.main.noItems" />
        </Element>
        <div className="dFlex justifyContentCenter alignItemsCenter">
          <Element
            elementName="a"
            href={`${COMPONENTS.dashboard.components.dashboard.route}`}
            className={classes.goDashboardBtn}
            style={{
              backgroundColor: '#2C73E8',
              color: '#FFFFFF',
            }}
          >
            <Translate value="cartAndOrders.orderConfirmation.goDashboard" />
          </Element>
        </div>
      </div>
    </div>
  )
}
